<template>
  <div class="footer-box">
    <div
      style="width: 45px; height: 30px; text-align: center"
      @click="recordAudio()"
      v-show="recordAudioFlg"
    >
      <img
        id="img"
        src="../assets/img/mic.png"
        style="width: 30px; height: 28px; cursor: pointer"
      />
    </div>
    <div
      style="width: 45px; height: 30px; text-align: center"
      @click="stopRecordAudio()"
      v-show="!recordAudioFlg"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        fill="#FF0602"
        style="height: 28px; width: 28px; cursor: pointer"
        class="icon icon breath_light"
      >
        <rect x="10" y="10" width="12" height="12"></rect>
        <path
          d="M15.6,2.1c-7.7,0-14,6.3-14,14s6.3,14,14,14s14-6.3,14-14S23.3,2.1,15.6,2.1z M15.6,28.1 c-6.6,0-12-5.4-12-12s5.4-12,12-12s12,5.4,12,12S22.2,28.1,15.6,28.1z"
        ></path>
      </svg>
    </div>
    <!-- <el-input
      v-model="inputText"
      placeholder="回答を入力してください"
      @change="textChangeEvent"
    ></el-input> -->

    <!-- <el-autocomplete
      id="autoInput"
      ref="autoInput"
      type="textarea"
      size="mini"
      class="inline-input"
      v-model="inputText"
      :fetch-suggestions="querySearch"
      placeholder="回答を入力してください"
      :trigger-on-focus="false"
      @focus="textChangeEvent"
      @keydown.enter.native="carriageReturn($event)"
    ></el-autocomplete> -->

    <el-autocomplete
      id="autoInput"
      type="textarea"
      :debounce="0"
      :autosize="{ minRows: 1, maxRows: 5 }"
      ref="autoInput"
      size="mini"
      class="inline-input"
      v-model="inputText"
      :fetch-suggestions="querySearch"
      placeholder="回答を入力してください"
      :trigger-on-focus="false"
      popper-class="selection-style"
      :popper-append-to-body="false"
      @focus="inputOn()"
      @input="textChangeEvent()"
      @keydown.enter.native="carriageReturn($event)"
    ></el-autocomplete>

    <!-- <el-input size="mini" v-model="input" placeholder="回答を入力してください" @keyup.enter.native ="enterClick()"></el-input> -->
    <!-- <el-autocomplete
      id="autoInput"
      type="textarea"
      :debounce="0"
      :autosize="{ minRows: 1, maxRows: 5 }"
      :fetch-suggestions="querySearch"
      ref="autoInput"
      size="mini"
      class="inline-input"
      placeholder="回答を入力してください"
      :trigger-on-focus="false"
      popper-class="selection-style"
      :popper-append-to-body="false"
      change
    ></el-autocomplete> -->

    <!-- <textarea id="autoInput" :style="{'height': height}" style="overflow-y:auto;" v-model="input" class="xw-content-textarea" ref="autoInput" type="text" :placeholder="autoInputHolder"></textarea> -->
    <!-- <el-button size="mini" @click="enterClick">送信</el-button> -->
    <div
      style="width: 45px; height: 30px; text-align: center"
      @click="enterClick()"
    ></div>
    <div
      style="width: 45px; height: 30px; text-align: center"
      @click="sendMessage()"
    >
      <img
        id="img"
        src="../assets/img/send.png"
        style="width: 30px; height: 28px; cursor: pointer"
      />
    </div>
  </div>
</template>

<script>
import AzureSpeech from "@/utils/azure-speech.js"
import moment from "moment";
var stream = "";
export default {
  data() {
    return {
      recordAudioFlg: true,
      operatorBtn: true,
      questionBtn: true,
      records: [],

      inputText: "",
      autoInputHolder: "",
      onInputFlg:"",
    };
  },
  methods: {
    recordAudio() {
      let that = this;
      this.$store.state.sysInit.sttConfig["format"] = true;
      this.$store.state.sysInit.sttConfig["keepMicrophone"] = false;

      this.$store.state.sysInit.sttConfig["outputElement"] =
        document.getElementById("autoInput");
      stream = AzureSpeech.SpeechToText.recognizeMicrophone(
        this.$store.state.sysInit.sttConfig
      );
      stream.on("data", function () {
        that.inputText = document.getElementById("autoInput").value;
        // that.$nextTick(() => {
        //   // that.$refs.autoInput.$attrs.rows = 2;
        //   that.inputrow = 2;
        // })
      });
      this.recordAudioFlg = false;
    },
    stopRecordAudio() {
      if (stream) {
        stream.stop();
        this.recordAudioFlg = true;
      }
    },

    inputOn() {
      this.onInputFlg = true;
    },

      

    textChangeEvent() {
      // isWriting
      if (this.$store.state.sysInit.manualChatQuestionerId) {
        if (this.inputText && this.onInputFlg) {
          this.$store.state.sysInit.manualMessageStatus = "isWriting";
          this.$store.dispatch("sysInit/changeManualChatMessageStatus");
        } else {
          console.log("this.inputText is null");
        }
      }
    },

    sendMessage() {
      if (this.$store.state.sysInit.manualChatQuestionerId) {
        if (this.inputText) {
            this.$store.state.sysInit.manualMessageStatus = "sendEnd";
            this.$store.dispatch("sysInit/manualChatSendMessage", {
              message: this.inputText,
            });
            let data = {
               id:this.$store.state.sysInit.messageId++,
              flag: "left",
              userId: this.$store.state.sysInit.manualChatQuestionerId,
              text: this.inputText,
              checked: false,
              user: this.$store.state.sysInit.html_const.cons_216_operator,
              messageTime: moment().tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm:ss"),
              status: false,
              issueId:this.$store.state.sysInit.manualChatModeIssueId,
              isChatbot:false,
              // chatbotIssueId:this.$store.state.sysInit.manualChatbotIssueId
            };
            this.$store.state.sysInit.manualChatMessageList.push(data);
            this.$store.dispatch(
              "redmine/manualChatMessageRecord",
              {},
              { root: true }
            );

            let item = {
              flag: data.flag,
              text: data.text,
              mode: this.$store.state.sysInit.ws_mode,
            };

            this.$store.dispatch("stt/fetchKeywordByDialog", {
              ...item,
              request_id: this.$store.state.redmine.issue_id,
              keywordRate: this.$store.state.sysInit.keywordRate,
            });
          }
      }

      console.log(
        "op__manualChatMessageList",
        this.$store.state.sysInit.manualChatMessageList
      );
      this.inputText = null;
    },

    querySearch(queryString, callBack) {
      //  this.$store.state.sysInit.autocompleteData
      // debugger
      // var autocompleteData = this.autocompleteData
      // var results = queryString ? autocompleteData.filter(item => {return item.value.toLowerCase().includes(queryString.toLowerCase())}) : autocompleteData
      // callBack(results)
      var alternatives = [];
      var rets = [];
      var ret = {};
      for (
        var i = 0;
        i < this.$store.state.sysInit.autocompleteData.length;
        i++
      ) {
        let restaurant = this.$store.state.sysInit.autocompleteData[i];
        if (restaurant["text"].indexOf(queryString) != -1) {
          if (alternatives.length == 0) {
            alternatives.push(restaurant);
            ret = {};
            ret["value"] = restaurant["text"];
            rets.push(ret);
          } else {
            if (
              restaurant["format"] !=
              alternatives[alternatives.length - 1]["format"]
            ) {
              alternatives.push(restaurant);
              ret = {};
              ret["value"] = restaurant["text"];
              rets.push(ret);
            }
          }
        } else if (
          restaurant["text"].toLowerCase().indexOf(queryString.toLowerCase()) !=
          -1
        ) {
          if (alternatives.length == 0) {
            alternatives.push(restaurant);
            ret = {};
            ret["value"] = restaurant["text"];
            rets.push(ret);
          } else {
            if (
              restaurant["format"] !=
              alternatives[alternatives.length - 1]["format"]
            ) {
              alternatives.push(restaurant);
              ret = {};
              ret["value"] = restaurant["text"];
              rets.push(ret);
            }
          }
        }
      }

      rets.forEach((item) => {
        item["index"] = item.value
          .toLowerCase()
          .indexOf(queryString.toLowerCase());
      });
      rets.sort((a, b) => {
        return a.index - b.index;
      });
      callBack(rets);
    },

    enterClick() {
      let inputValue = document.getElementById("autoInput").value;
      if (inputValue == null || inputValue == "" || inputValue == "\n") {
        document.getElementById("autoInput").value = "";
        // this.message = this.$t("lang.input_error");
        // this.messageVisible = true;
        this.$refs.autoInput.focus();
        return;
      }
      let that = this;
      var interval = setInterval(function () {
        if (!(stream && stream.readable)) {
          clearInterval(interval);
          this.inputText = inputValue;
          that.sendMessage();
          document.getElementById("autoInput").value = "";
          // resize(document.getElementById('input-text'));
        }
      }, 100);
      this.stopRecordAudio();
    },

    carriageReturn(event) {
      if (event.keyCode == 13) {
        event.preventDefault();
        let inputValue = document.getElementById("autoInput").value;
        if (inputValue == null || inputValue == "" || inputValue == "\n") {
          document.getElementById("autoInput").value = "";
          this.message = this.$t("lang.input_error");
          this.messageVisible = true;
          this.$refs.autoInput.focus();
          return;
        }
        let that = this;
        var interval = setInterval(function () {
          if (!(stream && stream.readable)) {
            clearInterval(interval);
            this.inputText = inputValue;
            that.sendMessage();
            document.getElementById("autoInput").value = "";
          }
        }, 100);
        this.stopRecordAudio();
      }
    },

    //     enterClick() {
    //       let inputValue = document.getElementById("autoInput").value;
    //       if (inputValue == null || inputValue == "" || inputValue == "\n") {
    //         document.getElementById("autoInput").value = "";
    //         this.message = this.$t("lang.input_error");
    //         this.messageVisible = true;
    //         this.$refs.autoInput.focus();
    //         return;
    //       }
    //       let that = this;
    //       var interval = setInterval(function () {
    //         if (!(stream && stream.readable)) {
    //           clearInterval(interval);
    //           that.sendMessage(inputValue);
    //           document.getElementById("autoInput").value = "";
    //           // resize(document.getElementById('input-text'));
    //         }
    //       }, 100);
    //       this.stopRecordAudio();
    //     },
    //     carriageReturn(event) {
    //       if (event.keyCode == 13) {
    //         event.preventDefault();
    //         let inputValue = document.getElementById("autoInput").value;
    //         if (inputValue == null || inputValue == "" || inputValue == "\n") {
    //           document.getElementById("autoInput").value = "";
    //           this.message = this.$t("lang.input_error");
    //           this.messageVisible = true;
    //           this.$refs.autoInput.focus();
    //           return;
    //         }
    //         let that = this;
    //         var interval = setInterval(function () {
    //           if (!(stream && stream.readable)) {
    //             clearInterval(interval);
    //             that.sendMessage(inputValue);
    //             document.getElementById("autoInput").value = "";
    //           }
    //         }, 100);
    //         this.stopRecordAudio();
    //       }
    //     },
    //      sendMessage(val) {
    //       this.operatorBtn = true;
    //       this.questionBtn = true;
    //       this.$nextTick(function(){
    //         this.input = ' ';
    //         this.input = '';
    //         var els = document.getElementsByClassName('badge-active');
    //         for (let i = 0; i < els.length; i++) {
    //           if (els[i].className.indexOf('el-button') != -1) {
    //             els[i].disabled = true;
    //             els[i].style.cursor = 'default';
    //             if (els[i].innerText == this.$store.state.htmlconst.cons_107_button_send) {
    //               els[i].style.boxShadow = '0 2px 1px 1px #e1e1e1';
    //               els[i].style.backgroundColor = '#C8F6F0';
    //             } else {
    //               els[i].style.borderColor = '#DCDFE6';
    //               els[i].style.color = '#606266';
    //               els[i].style.backgroundColor = '#FFF';
    //             }
    //           }
    //         }
    //         for (let j = this.records.length - 1; j >= 0; j--) {
    //           if (this.records[j].responseCnt) {
    //             this.records[j].rateFlg = true;
    //             this.records[j].textareaFlg = true;
    //             this.records[j].btnFlg = true;
    //             break;
    //           }
    //         }
    //         var disInterval = setInterval(function(){
    //           let dom = document.querySelectorAll('.el-autocomplete-suggestion');
    //           dom[0].style.display = status;
    //           if (!dom[0].style.display || dom[0].style.display != 'none'){
    //               clearInterval(disInterval);
    //               dom[0].style.display = 'none';
    //           }
    //         }, 0);
    //       });
    //       if (this.$store.state.responseFlg) {
    //         this.fullscreenLoading = true;
    //         let param = {};
    //         param.userId = sessionStorage.getItem("user_id");
    //         param.userName = sessionStorage.getItem("user_name");
    //         param.address = sessionStorage.getItem("login_id");
    //         param.description = this.$store.state.description;
    //         param.rate = this.evaluateValue;
    //         param.comment = this.evaluateTextarea;
    //         let dialog = this.$store.state.dialog.replace(/<br>/g, "\n");
    //         dialog = dialog.replace(/<.*?>/g, "");
    //         param.dialog = dialog;
    //         param.checklist1 = 0;
    //         param.checklist2 = 0;
    //         param.checklist3 = 0;
    //         param.checklist4 = 0;
    //         param.checklist5 = 0;
    //         param.responsed = this.$store.state.responseFlg ? "1" : "0";
    //         param.userDialog = this.$store.state.userDialog;
    //         var finalTitle = '';
    //         if (this.$store.state.title) {
    //           var title = this.lodash.uniq(this.$store.state.title);
    //           if (title) {
    //             for (let i = 0; i < title.length; i++) {
    //               if (!finalTitle) {
    //                 finalTitle = title[i];
    //               } else {
    //                 finalTitle += ' ';
    //                 finalTitle += title[i];
    //               }
    //             }
    //           }
    //         }
    //         param.title = finalTitle;
    //         param.faqid = this.$store.state.faqId;
    //         param.sms_flag = sessionStorage.getItem("tel_num") ? 1 : 0 ;
    //         param.telnum = sessionStorage.getItem("tel_num") || '';
    //         param.age = this.age;
    //         param.sex = this.sex;

    //         let that = this;
    //         api.sendQuestionary(param).then((res) => {
    //           that.fullscreenLoading = false;
    //           if (res.data.code != 0) {
    //             that.message = that.$store.state.htmlconst.cons_106_timeout;
    //             that.messageVisible = true;
    //           } else {
    //             that.resetConversationParameters();
    //             that.sendMessageMain(val);
    //           }
    //         }, (err) => {
    //           that.fullscreenLoading = false;
    //           console.log('sendQuestionary',err);
    //         });
    //       } else {
    //         this.sendMessageMain(val);
    //       }
    //       this.$refs.autoInput.focus();
    //     },
    //       resetConversationParameters() {
    //       this.$store.state.userDialog = '';
    //       this.$store.state.dialog = '';
    //       this.$store.state.faqId = '';
    //       this.$store.state.issuesId = '';
    //       this.$store.state.title = [];
    //       this.$store.state.responseFlg = false;
    //       this.$store.state.description = '';
    //     },
    //      sendMessageMain(val) {
    //       if (!this.onlyFlg) {
    //         let userRecord = {};
    //         this.recordsId++;
    //         userRecord.id = this.recordsId;
    //         userRecord.type = 'user';
    //         userRecord.message = val;
    //         userRecord.time = this.formatDate()
    //         this.setDialog(userRecord);
    //         this.setUserDialog(val);

    //         this.records.push(userRecord);

    //         let watsonWaitRecord = {}
    //         this.recordsId++;
    //         watsonWaitRecord.id = this.recordsId;
    //         watsonWaitRecord.message = '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;';
    //         watsonWaitRecord.type = 'serviceWait';
    //         this.records.push(watsonWaitRecord);
    //       }

    //       // setTimeout(() => {
    //       //   this.records.push(watsonWaitRecord);
    //       // }, 200);

    //       document.getElementById('autoInput').value = '';
    //       this.messagesContainerTimer = setTimeout(()=>{
    //         this.$refs.xwBody.scrollTop = this.$refs.xwBody.scrollHeight;
    //         clearTimeout(this.messagesContainerTimer);
    //       },0);

    //       let param = {
    //         restart: false,
    //         text: val,
    //         ques_list: this.$store.state.ques_list,
    //         conds: this.$store.state.conds,
    //         title: this.$store.state.title,
    //         lastObjects: this.$store.state.lastObject,
    //         userId: sessionStorage.getItem("user_id")
    //       }
    //       this.onlyFlg = false;
    //       let that = this;
    //       api.sendMessage(param).then((res) => {
    //         if (res.data.code != 0) {
    //           that.message = that.$t('lang.system_error');
    //           that.messageVisible = true;
    //           return;
    //         }

    //         if (res.data.data.notFoundFlg) {
    //           that.records.splice(that.records.length - 1, 1);
    //           that.questionBtn = false;
    //           let watsonRecord = {};
    //           watsonRecord.id = that.recordsId;
    //           watsonRecord.message = that.$store.state.htmlconst.cons_111_not_find_text;
    //           watsonRecord.type = 'service';
    //           watsonRecord.time = that.formatDate();
    //           watsonRecord.messageBottom = '<br><br>' + that.$store.state.htmlconst.cons_109_saratoi_reponse;

    //           that.$store.state.description = that.$store.state.htmlconst.cons_111_not_find_text;
    //           that.setDialog(watsonRecord);

    //           that.records.push(watsonRecord);
    //           // setTimeout(() => {
    //           //   that.records.push(watsonRecord);
    //           // }, 200);
    //           that.messagesContainerTimer = setTimeout(()=>{
    //             that.$refs.xwBody.scrollTop = that.$refs.xwBody.scrollHeight;
    //             clearTimeout(that.messagesContainerTimer);
    //           },0);
    //           return;
    //         }

    //         if (res.data.data.onlyFlg) {
    //           that.onlyFlg = res.data.data.onlyFlg;
    //           that.$store.state.conds = res.data.data.conds;
    //           that.$store.state.ques_list = res.data.data.ques_list;
    //           that.$store.state.title = res.data.data.title;
    //           that.$store.state.lastObject = res.data.data.objects.output;

    //           let watsonRecord = {};
    //           that.recordsId++;
    //           watsonRecord.id = that.recordsId;
    //           watsonRecord.type = 'service';
    //           watsonRecord.message = '<b>' + that.$store.state.htmlconst.cons_109_saratoi_prompt + '</b>';
    //           let buttons = [];
    //           let outputData = res.data.data.objects.output;
    //           let keyValue = '';
    //           for (let i = 0; i < outputData.length; i++) {
    //             let button = {};
    //             button.btnTitle = '<b>' + outputData[i].type + '</b>';
    //             let labels = [];
    //             for (let key in outputData[i].labels) {
    //               keyValue = key;
    //               labels.push(key);
    //             }
    //             button.btnName = labels;
    //             button.spanShow = true;
    //             buttons.push(button);
    //           }
    //           watsonRecord.button = buttons;
    //           watsonRecord.time = that.formatDate();
    //           that.setDialog(watsonRecord);

    //           that.sendMessageMain(keyValue);
    //           return;
    //         }

    //         that.records.splice(that.records.length - 1, 1);
    //         if (res.data.data.responseFlg) {
    //           that.$store.state.responseFlg = true;
    //           that.$store.state.title = res.data.data.objects[0].title;
    //           that.$store.state.faqId = res.data.data.objects[0].faqid;
    //           that.$store.state.conds = [];
    //           that.$store.state.ques_list = [];
    //           that.$store.state.lastObject = [];
    //           let watsonRecord = {};
    //           watsonRecord.id = that.recordsId;
    //           watsonRecord.message = res.data.data.objects[0].response.replace(/\n/g, "<br><br>");
    //           watsonRecord.type = 'service';
    //           watsonRecord.time = that.formatDate();
    //           watsonRecord.messageBottom = '<br><br>' + that.$store.state.htmlconst.cons_109_saratoi_reponse;

    //           that.$store.state.description = res.data.data.objects[0].response.replace(/\n/g, "<br><br>");
    //           that.setDialog(watsonRecord);

    //           that.records.push(watsonRecord);

    //           let evaluateRecord = {};
    //           that.responseCnt++;
    //           that.recordsId++;
    //           evaluateRecord.responseCnt = that.responseCnt;
    //           evaluateRecord.id = that.recordsId;
    //           evaluateRecord.evaluate = true;
    //           evaluateRecord.type = 'service';
    //           evaluateRecord.rateFlg = false;
    //           evaluateRecord.evaluateValue = 0;
    //           evaluateRecord.textareaFlg = false;
    //           evaluateRecord.textarea = '';
    //           evaluateRecord.btnFlg = false;
    //           evaluateRecord.time = that.formatDate();
    //           that.records.push(evaluateRecord);

    //           // setTimeout(() => {
    //           //   that.records.push(watsonRecord);
    //           // }, 200);
    //           that.messagesContainerTimer = setTimeout(()=>{
    //             that.$refs.xwBody.scrollTop = that.$refs.xwBody.scrollHeight;
    //             clearTimeout(that.messagesContainerTimer);
    //           },0);
    //           return;
    //         }
    //         that.$store.state.conds = res.data.data.conds;
    //         that.$store.state.ques_list = res.data.data.ques_list;
    //         that.$store.state.title = res.data.data.title;
    //         that.$store.state.lastObject = res.data.data.objects.output;

    //         let watsonRecord = {};
    //         that.recordsId++;
    //         watsonRecord.id = that.recordsId;
    //         watsonRecord.type = 'service';
    //         watsonRecord.message = '<b>' + that.$store.state.htmlconst.cons_109_saratoi_prompt + '</b>';
    //         let buttons = [];
    //         let outputData = res.data.data.objects.output;
    //         for (let i = 0; i < outputData.length; i++) {
    //           let button = {};
    //           button.btnTitle = '<b>' + outputData[i].type + '</b>';
    //           let labels = [];
    //           for (let key in outputData[i].labels) {
    //             labels.push(key);
    //           }
    //           button.btnName = labels;
    //           button.spanShow = true;
    //           buttons.push(button);
    //         }
    //         watsonRecord.button = buttons;
    //         watsonRecord.time = that.formatDate();
    //         that.setDialog(watsonRecord);

    //         that.records.push(watsonRecord);
    //         that.messagesContainerTimer = setTimeout(()=>{
    //           that.$refs.xwBody.scrollTop = that.$refs.xwBody.scrollHeight;
    //           clearTimeout(that.messagesContainerTimer);
    //         },0);
    //       }, (err) => {
    //         console.log('sendMessageMain',err);
    //       });
    //     },
    //      setDialog(record) {
    //       let time = this.$moment().format("YYYY-MM-DD HH:mm");
    //       this.$store.state.dialog += "\n--------\n";
    //       if (record.type == 'service') {
    //         this.$store.state.dialog += "system:" + '(' +  time + ')';
    //         this.$store.state.dialog += record.message;
    //         if (record.messageBottom) {
    //           this.$store.state.dialog += record.messageBottom;
    //         } else if (record.button) {
    //           for (let i = 0; i < record.button.length; i++) {
    //             this.$store.state.dialog += '\n' + record.button[i].btnTitle + '\n';
    //             if (record.button[i].spanShow) {
    //               this.$store.state.dialog += '例えば：';
    //             }
    //             for (let j = 0; j < record.button[i].btnName.length; j++) {
    //               this.$store.state.dialog += record.button[i].btnName[j];
    //             }
    //           }
    //         }
    //       } else {
    //         this.$store.state.dialog += "user:" + '(' +  time + ')' + record.message;
    //       }
    //     },
  },
};
</script>
<style style lang="scss" scoped>
.footer-box {
  background-image: linear-gradient(to right, #5aaafa 0%, #41d6c3 100%);
  height: fit-content;
  padding: 8px 0px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  // .el-input {
  //   width: 80%;
  //   margin: 0px 10px;
  // }
  .el-autocomplete {
    flex: 1;
    margin: 0px 0px;
  }
  .el-button--mini {
    margin: 0px 10px;
  }
  :deep(.el-autocomplete-suggestion li) {
    padding: 10px 0px;
    white-space: normal;
    line-height: normal;
  }
  :deep(.el-textarea__inner) {
    resize: none;
    // height: 36px!important;
    padding: 5px 0px;
    font-size: 16px;
    color: inherit;
  }
}
</style>